import React, {useEffect, useState} from "react"
import {Button, Card, Col, Modal, notification, Row, Typography} from "antd"
import {useId24} from "../../../drivers/id24/Id24Provider"
import {OrganizationTable} from "./components/OrganizationTable"
import {AddingOrganizationData, EditOrganization} from "./components/EditOrganization"
import {
  LoginSettingType,
  Organization,
  OrganizationService,
  OrganizationStatus
} from "../../../services/organization-service"
import {loadAppConfig, NodeEnvironment} from "../../../config/app-config"

const { Title } = Typography

export const OrganizationManagement: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24()
  const [addOrganizeModalVisible, setAddOrganizeModalVisible] = useState<boolean>(false)
  const [organizations, setOrganizations] = useState<Organization[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [creatingOrganization, setCreatingOrganization] = useState(false)
  const { nodeEnvironment } = loadAppConfig()
  const enableDeleteOrganization = nodeEnvironment === NodeEnvironment.Development

  const organizationService = OrganizationService(id24Axios())

  useEffect(() => {
    reloadOrganizations()
  }, [])

  const reloadOrganizations = () => {
    setLoading(true)
    organizationService
      .getOrganizations()
      .then(organizations => {
        setOrganizations(organizations)
        setLoading(false)
      })
  }

  const onConfirmAddOrganization = async (organization: AddingOrganizationData) => {
    setCreatingOrganization(true)
    const response = await organizationService.createOrganizations({
      name: organization.name,
      description: organization.description,
      email: organization.email,
      username: organization.username,
      status: OrganizationStatus.Active,
      password: "",
      employeeId: "",
      loginSettings: [
        { type: LoginSettingType.Classic },
        ...(organization.phoneVerification ? [{ type: LoginSettingType.DeviceVerification }] : [])
      ]
    })
    setCreatingOrganization(false)
    if (response==="success") {
      notification.success({message: "success"})
      setAddOrganizeModalVisible(false)
      reloadOrganizations()
    } else {
      notification.error({ message: "Error" })
    }
  }

  const onDeleteOrganization = (organizationId: string) => {
    organizationService
      .deleteOrganizations(organizationId)
      .then(() => {
        notification.success({message: "Organization deleted"})
        reloadOrganizations()
      })
      .catch(() => notification.error({ message: "Unable to delete organization"}))
  }
  return <>
    <Row>
      <Col>
        <Title>Organization</Title>
      </Col>
    </Row>

    <Row>
      <Col span="24">
        <Card>
          <Row justify="end">
            <Col>
              <Button
                style={{ marginLeft: 10 }}
                onClick={() => setAddOrganizeModalVisible(true)}
                type="primary"
              >
                +Add organization
              </Button>
            </Col>
          </Row>
          <br />
          <Modal
            title="Add Organization"
            visible={addOrganizeModalVisible}
            onCancel={() => setAddOrganizeModalVisible(false)}
            footer={null}
          >
            <EditOrganization
              submitLabel="Add"
              onConfirm={onConfirmAddOrganization}
              editing={creatingOrganization}
            />
          </Modal>
          <OrganizationTable
            organizations={organizations}
            loading={loading}
            enableDelete={enableDeleteOrganization}
            onDeleteOrganization={onDeleteOrganization}
          />
        </Card>
      </Col>
    </Row>
  </>
}
